import { render, staticRenderFns } from "./RelanceTemplatesFieldset.vue?vue&type=template&id=692133a6"
import script from "./RelanceTemplatesFieldset.vue?vue&type=script&lang=ts"
export * from "./RelanceTemplatesFieldset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports